import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapCollection } from '../normalize'

export interface HubUser {
  email: string
  [key: string]: unknown
}

export default async function getUsers({
  query,
  signal,
}: {
  query: string
  signal?: AbortSignal
}): Promise<HubUser[]> {
  const response = await apiClient.get(endpoints.users, { params: { query }, signal })
  return unwrapCollection<HubUser>(response)
}
